import styled from 'styled-components';
import {
  background,
  border,
  color,
  compose,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
} from 'styled-system';

const styleProps = compose(
  background,
  border,
  color,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
);

export const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  display: table;
  width: 100%;

  ${styleProps}
`;
